export class PreListCurrencyChanges {
  user: string;
  message: string;
  createdAt: string;

  constructor(input: any = {}) {
    this.user = input.user;
    this.message = input.message;
    this.createdAt = input.created_at;
  }
}

export class PreListedCurrencyModel {
  id: number;
  currencyPersianName: string;
  currencyEnglishName: string;
  currencyId: string;
  currencyIconPath: string;
  preListImagePath: string;
  color!: string;
  networkId: string;
  withdrawFee: string;
  minimumWithdrawAmount: string;
  memoLabel: string;
  depositContract: string;
  currencyPrecision: number;
  contractPrecision: number | null;
  mainWalletBalance: string;
  userRobotEnable: boolean;
  tradingviewSymbol: string;
  walletAlgorithm: string;
  categoryId: number;
  irrQuoteCurrencyPrecision: number | null;
  irrBaseCurrencyPrecision: number | null;
  usdtQuoteCurrencyPrecision: number | null;
  usdtBaseCurrencyPrecision: number | null;
  currencyModalImage: string;
  currencyModalImageMobile: string;
  currencyModalImageLight!: string;
  currencyModalImageMobileLight!: string;
  mainImagePath: string | null;
  createdAt: string | null;
  updatedAt: string;
  techTeamStatus!: boolean;
  financeTeamStatus!: boolean;
  marketingTeamStatus!: boolean;
  productTeamStatus!: boolean;
  financeApproved!: boolean;
  techApproved!: boolean;
  marketingApproved!: boolean;
  productApproved!: boolean;
  listedAt: string;
  marketingSingleCoinTitle: string;
  marketingSingleCoinMainTitle: string;
  marketingSingleCoinMetaDescription: string;
  marketingSingleCoinSummary: string;
  marketingSingleCoinDescription: string;

  currencyPersianNameIsSet!: boolean;
  currencyEnglishNameIsSet!: boolean;
  currencyIdIsSet!: boolean;
  currencyIconPathIsSet!: boolean;
  preListImagePathIsSet!: boolean;
  colorIsSet!: boolean;
  networkIdIsSet!: boolean;
  withdrawFeeIsSet!: boolean;
  minimumWithdrawAmountIsSet!: boolean;
  memoLabelIsSet!: boolean;
  depositContractIsSet!: boolean;
  contractPrecisionIsSet!: boolean;
  mainWalletBalanceIsSet!: boolean;
  userRobotEnableIsSet!: boolean;
  tradingviewSymbolIsSet!: boolean;
  walletAlgorithmIsSet!: boolean;
  irrQuoteCurrencyPrecisionIsSet!: boolean;
  irrBaseCurrencyPrecisionIsSet!: boolean;
  usdtQuoteCurrencyPrecisionIsSet!: boolean;
  usdtBaseCurrencyPrecisionIsSet!: boolean;
  categoryIdIsSet!: boolean;
  listedAtIsSet!: boolean;
  currencyPrecisionIsSet!: boolean;

  marketingSingleCoinTitleIsSet: boolean;
  marketingSingleCoinMainTitleIsSet: boolean;
  marketingSingleCoinMetaDescriptionIsSet: boolean;
  marketingSingleCoinSummaryIsSet: boolean;
  marketingSingleCoinDescriptionIsSet: boolean;

  constructor(input: any = {}) {
    this.id = input.id ?? 0;

    //Marketing
    this.marketingSingleCoinTitle = input.marketing_single_coin_title ?? '';
    this.marketingSingleCoinMetaDescription = input.marketing_single_coin_meta_description ?? '';
    this.marketingSingleCoinMainTitle = input.marketing_single_coin_main_title ?? '';
    this.marketingSingleCoinSummary = input.marketing_single_coin_summary ?? '';
    this.marketingSingleCoinDescription = input.marketing_single_coin_description ?? '';

    this.currencyPersianName = input.currency_persian_name ?? '';
    this.currencyEnglishName = input.currency_english_name ?? '';
    this.currencyId = input.currency_id ?? '';
    this.currencyIconPath = input.currency_icon_path ?? '';
    this.preListImagePath = input.pre_list_image_path ?? '';
    this.networkId = input.network_id ?? '';
    this.withdrawFee = input.withdraw_fee ?? '';
    this.minimumWithdrawAmount = input.minimum_withdraw_amount ?? '';
    this.memoLabel = input.memo_label ?? '';
    this.depositContract = input.deposit_contract ?? '';
    this.contractPrecision = input.contract_precision ?? null;
    this.mainWalletBalance = input.main_wallet_balance ?? '';
    this.userRobotEnable = input.user_robot_enable ?? false;
    this.walletAlgorithm = input.algorithm ?? '';
    this.tradingviewSymbol = input.tradingview_symbol ?? '';
    this.irrQuoteCurrencyPrecision = input.irr_quote_currency_precision ?? null;
    this.irrBaseCurrencyPrecision = input.irr_base_currency_precision ?? null;
    this.usdtQuoteCurrencyPrecision = input.usdt_quote_currency_precision ?? null;
    this.usdtBaseCurrencyPrecision = input.usdt_base_currency_precision ?? null;
    this.createdAt = input.created_at ?? null;
    this.updatedAt = input.updated_at ?? '';
    this.techTeamStatus = input.tech_team ?? false;
    this.financeTeamStatus = input.finance_team ?? false;
    this.marketingTeamStatus = input.marketing_team ?? false;
    this.productTeamStatus = input.product_team ?? false;
    this.financeApproved = input.finance_approved ?? false;
    this.techApproved = input.tech_approved ?? false;
    this.marketingApproved = input.marketing_approved ?? false;
    this.productApproved = input.product_approved ?? false;
    this.color = input.color ?? '';
    this.categoryId = input.category_id ?? 7;
    this.listedAt = input.pre_list_at ?? null;
    this.currencyPrecision = input.currency_precision ?? '';
    this.currencyModalImage = input.currency_list_modal ?? '';
    this.currencyModalImageMobile = input.currency_list_modal_mobile ?? '';

    this.currencyModalImageLight = input.currency_list_modal_light ?? '';
    this.currencyModalImageMobileLight = input.currency_list_modal_mobile_light ?? '';

    // Initializing boolean states
    this.currencyPersianNameIsSet = !!input.currency_persian_name;
    this.currencyEnglishNameIsSet = !!input.currency_english_name;
    this.currencyIdIsSet = !!input.currency_id;
    this.currencyIconPathIsSet = !!input.currency_icon_path;
    this.preListImagePathIsSet = !!input.pre_list_image_path;
    this.mainImagePath = input.main_image_path ?? '';
    this.colorIsSet = !!input.color;
    this.networkIdIsSet = !!input.network_id;
    this.withdrawFeeIsSet = !!input.withdraw_fee;
    this.minimumWithdrawAmountIsSet = !!input.minimum_withdraw_amount;
    this.memoLabelIsSet = !!input.memo_label;
    this.depositContractIsSet = !!input.deposit_contract;
    this.contractPrecisionIsSet = input.contract_precision !== null;
    this.mainWalletBalanceIsSet = !!input.main_wallet_balance;
    this.userRobotEnableIsSet = !!input.user_robot_enable;
    this.tradingviewSymbolIsSet = !!input.tradingview_symbol;
    this.walletAlgorithmIsSet = !!input.algorithm;
    this.irrQuoteCurrencyPrecisionIsSet = input.irr_quote_currency_precision !== null;
    this.irrBaseCurrencyPrecisionIsSet = input.irr_base_currency_precision !== null;
    this.usdtQuoteCurrencyPrecisionIsSet = input.usdt_quote_currency_precision !== null;
    this.usdtBaseCurrencyPrecisionIsSet = input.usdt_base_currency_precision !== null;
    this.categoryIdIsSet = !!input.category_id;
    this.listedAtIsSet = !!input.pre_list_at;
    this.currencyPrecisionIsSet = input.currency_precision !== null;

    this.marketingSingleCoinTitleIsSet = input.marketing_single_coin_title != null ?? '';
    this.marketingSingleCoinMetaDescriptionIsSet = input.marketing_single_coin_meta_description != null;
    this.marketingSingleCoinMainTitleIsSet = input.marketing_single_coin_main_title != null;
    this.marketingSingleCoinSummaryIsSet = input.marketing_single_coin_summary != null;
    this.marketingSingleCoinDescriptionIsSet = input.marketing_single_coin_description != null;

  }
}
